/*
* 商品管理
* */
export const GOODSGETPAGE = 'GOODSGETPAGE'
export const GOODSADD = 'GOODSADD'
export const GOODSUPDATE = 'GOODSUPDATE'
export const GOODSDELETE = 'GOODSDELETE'
export const DICTGETCHILDS = 'DICTGETCHILDS'
export const DICTGETCHILDS2 = 'DICTGETCHILDS2'
export const SUPPLIERGETLISTS = 'SUPPLIERGETLISTS'
export const GOODSGETGOODS = 'GOODSGETGOODS'
export const IMPORTGOODS = 'IMPORTGOODS'
export const DOWNLOADEXCEL = 'DOWNLOADEXCEL'
export const GETISACC = 'GETISACC'
export const GETNOTPASSGOOD = 'GETNOTPASSGOOD'
export const GETNOTPASSGOODS = 'GETNOTPASSGOODS'
export const GETNOTPASSGOODD = 'GETNOTPASSGOODD'
export const GOODSPASSGOOD = 'GOODSPASSGOOD'
export const OPENDATEMANAGE = 'OPENDATEMANAGE' // 开启生产日期管理
export const GETCOMPANY = 'GETCOMPANY'// 获取单位
export const YGCCODE = 'YGCCODE'
export const CLASSIFICATION = 'CLASSIFICATION'
export const ATTRIBUTES = 'ATTRIBUTES'



// WEBPACK FOOTER //
// ./src/store/goodsManage/types.js